import SectionHeader from '../common/SectionHeader';

function BusinessValueSection({ factorStreetFit, items }) {
  return (
    <section className="service-section service-value-section">
      <div className="container">
        <SectionHeader
          eyebrow="Investor View"
          title="Business value inside FactorStreet"
          description={factorStreetFit}
        />
        <div className="service-value-grid">
          {items.map((item) => (
            <article className="service-value-card" key={item}>
              <h3>{item}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BusinessValueSection;
